import gql from 'graphql-tag';
import casesService from '~lib/common/providers/casesService';

import caseConfQueries from '~lib/common/queries/CaseConfiguration';

export default async function saveCaseConf(caseConf) {
  await casesService.mutate({
    mutation: caseConf.id
      ? gql(caseConfQueries.save)
      : gql(caseConfQueries.add),
    variables: {
      value: caseConf,
    },
  });
}
